import React from "react";
import { Table } from "semantic-ui-react";
import "./tvList.css";

export default function genericTable(props) {
  const { i, user, increment } = props;

  return (
    <Table.Row className="ligne" key={user?.fk_id_patient1 + "a"}>
      <Table.Cell className="numero">
        {/* <div> */}
        <p
          className="patient"
          style={{
            backgroundColor: `${user.color}`,
            paddingLeft: "0.3em",
          }}
        >
          <span
            style={{ textAlign: "center", borderRadius: "1em" }}
            className="theNumber"
          >
            {i + increment}
          </span>
          {user.nom} {user.prenom}{" "}
        </p>
        {/* </div> */}
      </Table.Cell>
    </Table.Row>
  );
}
